import { appConfig } from '@/plugins/micleoConfig'

require('./overrides.scss')

// Skins
require('./skins/bordered.scss')
require('./skins/semi-dark.scss')

export default {
  theme: {
    themes: {
      ...appConfig.theme.themes,
    },
    dark:
      localStorage.getItem('active-theme') === null
        ? appConfig.theme.app.isDark
        : localStorage.getItem('active-theme') === 'dark',
  },
  rtl: appConfig.theme.app.isRtl,
}
